import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelFollowVisit } from "../../functions/Report.ExportCountVisit";
import { formatFollowVisit } from "../../utils/Report.Format";
import {
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  TABLE,
} from "../../../../utils/useStyle";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";

const optionsYear = GenerateOptionsYear();

const DropdownFollows = ({ year, setYear }) => {
  return (
    <div>
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
      />
    </div>
  );
};

const ReportFollowVisit = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [info, setInfo] = React.useState({
    level01: 0,
    level02: 0,
    level03: 0,
    level04: 0,
    all_level: 0,

    jan: {
      visit: 0,
      phone: 0,
    },
    feb: {
      visit: 0,
      phone: 0,
    },
    mar: {
      visit: 0,
      phone: 0,
    },
    apr: {
      visit: 0,
      phone: 0,
    },
    may: {
      visit: 0,
      phone: 0,
    },
    jun: {
      visit: 0,
      phone: 0,
    },
    jul: {
      visit: 0,
      phone: 0,
    },
    aug: {
      visit: 0,
      phone: 0,
    },
    sep: {
      visit: 0,
      phone: 0,
    },
    oct: {
      visit: 0,
      phone: 0,
    },
    nov: {
      visit: 0,
      phone: 0,
    },
    dec: {
      visit: 0,
      phone: 0,
    },
    //
  });

  const listTableVisit = [
    {
      name: "ม.ค.",
      visit: info?.jan?.visit,
      phone: info?.jan?.phone,
    },
    {
      name: "ก.พ.",
      visit: info?.feb?.visit,
      phone: info?.feb?.phone,
    },
    {
      name: "มี.ค.",
      visit: info?.mar?.visit,
      phone: info?.mar?.phone,
    },
    {
      name: "เม.ย.",
      visit: info?.apr?.visit,
      phone: info?.apr?.phone,
    },
    {
      name: "พ.ค.",
      visit: info?.may?.visit,
      phone: info?.may?.phone,
    },
    {
      name: "มิ.ย.",
      visit: info?.jun?.visit,
      phone: info?.jun?.phone,
    },
    {
      name: "ก.ค.",
      visit: info?.jul?.visit,
      phone: info?.jul?.phone,
    },
    {
      name: "ส.ค.",
      visit: info?.aug?.visit,
      phone: info?.aug?.phone,
    },
    {
      name: "ก.ย.",
      visit: info?.sep?.visit,
      phone: info?.sep?.phone,
    },
    {
      name: "ต.ค.",
      visit: info?.oct?.visit,
      phone: info?.oct?.phone,
    },
    {
      name: "พ.ย.",
      visit: info?.nov?.visit,
      phone: info?.nov?.phone,
    },
    {
      name: "ธ.ค.",
      visit: info?.dec?.visit,
      phone: info?.dec?.phone,
    },
  ];

  const listVistLimitday = [
    { name: "0-7 วัน", count: info?.level01 },
    { name: "8-14 วัน", count: info?.level02 },

    { name: "15-21 วัน", count: info?.level03 },

    { name: ">21 วัน", count: info?.level04 },
  ];

  React.useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getVisitReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setInfo(response.data);
        }
      } catch (error) {
        console.error("Error fetching visit report:", error);
      }
    };
    fetchData();
  }, [year, userDept]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const count = payload?.[0]?.value || 0;
      const percentage = ((count * 100) / info?.all_level).toFixed(1);

      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          <p className="label">{` ${count} (${percentage}%)`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      {/* 1 */}
      <div className="mt-20 mx-10 font-bold text-lg">
        รายงานจำนวนครั้งที่ผู้ป่วยได้รับการเยี่ยม
      </div>
      _____________________________________________________________________________________
      <div className="my-2">
        <>
          <div className={SCREENIPAD}>
            <div className={STYLEHEAD}>
              รายงานจำนวนครั้งที่ผู้ป่วยได้รับการเยี่ยม
              <div className={STYLEBODY}>
                แยกเป็นการโทร ฯ ติดตามหรือการเยี่ยมจริง "{year.label}"
              </div>
            </div>
            <div className={FLEXDROPDOWN}>
              <DropdownFollows year={year} setYear={setYear} />
              <ButtonExcel
                onClick={() => {
                  ExcelFollowVisit(formatFollowVisit(info), year, setLoading);
                }}
                loading={loading}
              />
            </div>
          </div>
          <div className={TABLE}>
            <BarChart
              width={700}
              height={300}
              data={listTableVisit}
              margin={{
                top: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />

              <Bar label={{ fill: "#111827" }} dataKey="visit" fill="#336600" />
              <Bar label={{ fill: "#111827" }} dataKey="phone" fill="#33CC33" />
            </BarChart>
          </div>
        </>
      </div>
      {/* 2 */}
      <div className="my-10">
        <div className={``}>
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  รายงานระยะห่างของการเยี่ยมแต่ละครั้ง
                  <div className={STYLEBODY}>
                    กรณีอายุสายน้อยกว่า 3 เดือน "{year.label}"
                  </div>
                </div>
              </div>

              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={TABLE}>
              <BarChart
                width={700}
                height={300}
                data={listVistLimitday}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />

                <Bar
                  dataKey="count"
                  fill="#339966"
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportFollowVisit;
